// Shared toast API. Import `toast` from here instead of 'react-toastify'.
// - identical active messages are deduplicated (same toastId while visible)
// - success auto-dismisses after 3s, errors after 5s
// - at most MAX_VISIBLE toasts are shown at once (excess waits in the library queue)
// - all toasts are cleared on route change so stale messages do not persist
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast as baseToast } from 'react-toastify';
import './toast.css';

export const MAX_VISIBLE = 2;
const DURATION = { success: 3000, error: 5000 };

const show = (type) => (message, options = {}) => {
  const toastId = options.toastId ?? (typeof message === 'string' ? `${type}:${message}` : undefined);
  return baseToast[type](message, { autoClose: DURATION[type], toastId, ...options });
};

export const toast = {
  success: show('success'),
  error: show('error'),
  info: show('info'),
  warn: show('warn'),
  warning: show('warning'),
  dismiss: (id) => baseToast.dismiss(id),
};

// Props for the single global <ToastContainer> mounted in App.jsx.
export const toastContainerProps = {
  position: 'top-right',
  autoClose: 3000,
  limit: MAX_VISIBLE,
  newestOnTop: true,
  closeOnClick: true,
  closeButton: true,
  pauseOnFocusLoss: true,
  theme: 'colored',
};

// Mount once inside the router: clears visible toasts whenever the path changes.
export function ToastRouteReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    baseToast.dismiss();
  }, [pathname]);
  return null;
}
